import React from 'react';
import { translate } from 'react-i18next';
import RaisedButton from 'material-ui/RaisedButton';
import json2csv from 'json2csv/lib/json2csv';
import compose from '../compose';
import user from '../Auth/user';
import firebase from '../firebase';
import Download from 'material-ui/svg-icons/file/file-download';

class CsvDownload extends React.Component {
  downloadCSV = () => {
    const {t, user} = this.props;
    const csvData = [];
    this.props.sales.forEach((sale) => {
      sale.paidAt = new Date(sale.paidAt).toLocaleString(user.language);
      csvData.push(sale);
    });

    const fields = ['paidAt', 'key', 'standName', 'productName', 'priceExcludeVat', 'vatInEuro', 'vat', 'price'];
    const fieldNames = [t('sale.paidAt'), t('sale.orderNumber'), t('stand.stand'), t('product.product'), t('receipt.priceExcludeVat'), t('receipt.vatEuro'), t('receipt.vat'), t('price')];
    const data = json2csv({ data: csvData, fields, fieldNames});

    const dataToCsvURI = encodeURI(`data:text/csv;charset=utf-8,${data}`);

    const link = document.createElement('a');
    link.setAttribute('href', dataToCsvURI);
    link.setAttribute('download', t('sale.sales') + '.csv');
    document.body.appendChild(link); // Required for FF
    link.click();
    document.body.removeChild(link);

  }

  render()  {
    const {t} = this.props;

    return (
      <RaisedButton primary
        label={t('sale.downloadCsv')}
        icon={<Download />}
        onTouchTap={this.downloadCSV}/>
    );
  }
}
const enhance = compose(translate(), firebase, user);

export default enhance(CsvDownload);



// WEBPACK FOOTER //
// ./src/Sale/CsvDownload.js